<div [hidden]="consulta">
    <div class="row">
        <div class="col-lg-12" style="padding: 0px;">
            <section class="widget">
                <!-- título -->
                <header>
                    <h3> {{sistemaService.NombrePantallaActual}}: {{accion.accion}}</h3>
                </header>

                <div class="divisor32"></div>
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <dropdownCustom [titulo]="'Ciclo'"
                            [opciones]="SelCiclo" [disabled]="ver"
                            [(ngModel)]="entidad.cicloid"
                            [valorName]="'cicloid'"
                            [displayValor]="'nombre'"
                            [buscar]="false"
                            [errorActivo]="errorActivo"
                            ></dropdownCustom>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12 col-12">
                        <inputCustom [titulo]="'Nombre del periodo de evaluación'" [disabled]="ver" [(ngModel)]="entidad.descripcion" [errorActivo]="errorActivo" ></inputCustom>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12" *ngIf="configuracionDatePicker">
                        <datePickerV2Custom #fechainicioperiodo [titulo]="'Fecha Inicio de Periodo'" [disabled]="ver"
                            [errorActivo]="errorActivo" [(ngModel)]="entidad.fechainicioperiodo"
                            [addConfiguracion]="configuracionDatePicker" (ngModelChange)="ValidarFechaInicioPeriodo()"
                            ></datePickerV2Custom>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12" *ngIf="configuracionDatePicker2">
                        <datePickerV2Custom #fechainicioacuerdo [titulo]="'Fecha Inicio Acuerdos'" [disabled]="ver"
                            [(ngModel)]="entidad.fechainicioacuerdos" [addConfiguracion]="configuracionDatePicker2"
                            [errorActivo]="errorActivo" (ngModelChange)="ValidarFechaInicioAcuerdo()"
                            ></datePickerV2Custom>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 col-12" *ngIf="configuracionDatePicker3">
                        <datePickerV2Custom #fechafinacuerdo [titulo]="'Fecha Fin Acuerdos'" [disabled]="ver" [addConfiguracion]="configuracionDatePicker3"
                            [(ngModel)]="entidad.fechafinacuerdos"
                            [errorActivo]="errorActivo" (ngModelChange)="ValidarFechaFinAcuerdo()"
                            ></datePickerV2Custom>
                    </div>
                </div>

                <div>
                    <h5>Selecciona los tipos de evaluación que se aplicarán en este periodo</h5>
                    <!-- datos -->
                    <dx-data-grid #grid
                        id="tablaperiodo"
                        (onContentReady)="onContentReady($event)"
                        [noDataText]="'Sin Datos'"
                        (onSelectionChanged)="onSelectionChanged($event)"
                        [dataSource]="SelDataPeriodoporTipo"
                        [repaintChangesOnly]="true"
                        [columnAutoWidth]="true"
                        >

                        <dxo-editing
                            mode="cell"
                            [allowUpdating]="true"
                            >
                        </dxo-editing>
                        <dxo-selection mode="multiple" [showCheckBoxesMode]="'always'" *ngIf="!ver"></dxo-selection>
                        <dxi-column
                            dataField="nombre"
                            caption="Tipo de evaluación" [allowEditing]="false">
                        </dxi-column>
                        <dxi-column
                            dataField="nivel"
                            caption="Nivel" [allowEditing]="false">
                        </dxi-column>
                        <dxi-column [allowEditing]="!ver"
                            caption="Fecha inicio evaluación"
                            dataField="fechainicioevaluacion"
                            dataType="date"
                            [allowEditing]="entidad.fechainicioperiodo && entidad.fechainicioacuerdos"
                            [showEditorAlways]="entidad.fechainicioperiodo && entidad.fechainicioacuerdos"
                            [editorOptions]="{ min: minDate, max: maxDate}">
                        </dxi-column>
                        <dxi-column [allowEditing]="!ver"
                            alignment="center"
                            dataField="preguntaloconoces"
                            caption="Pregunta ¿Lo Conoces?"
                            dataType="boolean"
                            >
                        </dxi-column>
                    </dx-data-grid>
                </div>
                <div class="divisor20"></div>
                <div class="row margen">
                    <div class="col-12">
                        <div class="panelBotonesFiltro">
                            <button matTooltip="Cancelar" class="boton botonSM filledBlanco"
                                    (click)="Salir()">
                                <span> {{'Cancelar'}}</span>
                            </button>
                            <div class="divisorH16 "></div>
                            <button matTooltip="Generar acuerdos" class="boton botonSM filled"
                            (click)="mensajeacuerdos()">
                              <span> {{'Generar acuerdos'}}</span>
                            </button>
                            <div class="divisorH16 "></div>
                            <div *ngIf="accion.accionid != 2">
                                <button matTooltip="Guardar" class="boton botonSM filled"
                                        (click)="Guardar()" [disabled]="ver"
                                        *ngIf="sistemaService.permisos.agregar">
                                    <span> {{'Guardar'}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>
